(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    module.controller('SyncSettingsOverviewController', ['ItemTableService', 'synchronisations', SyncSettingsOverviewControllerFn]);

    /* controlle for main syncsettings */
    function SyncSettingsOverviewControllerFn(ItemTableService, synchronisations) {
        var vm = this;

        // table service data
        vm.overview = null;

        activate();

        /* activation work */
        function activate() {
            vm.overview = ItemTableService;
            // init table-item list
            vm.overview.init(synchronisations);
        }
    }
})();